var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpCenter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7529 4.6046C12.4893 4.45895 12.1773 4.45895 11.9139 4.6046L3.08981 9.48184L2.25079 7.70031L11.0748 2.82307C11.8654 2.38612 12.8013 2.38612 13.5919 2.82307L22.4159 7.70031C23.1641 8.11382 23.4943 8.94017 23.4103 9.71949V15.5001C23.4103 16.0524 22.997 16.5001 22.4872 16.5001C21.9775 16.5001 21.5641 16.0524 21.5641 15.5001V11.7157L19.6872 12.7116V16.8053C19.6872 17.9091 19.1277 18.9238 18.2305 19.4469L13.6459 22.1204C12.8264 22.5982 11.8402 22.5982 11.0208 22.1204L6.43621 19.4469C5.53903 18.9238 4.97953 17.9091 4.97953 16.8053V12.7116L2.27774 11.278C0.911453 10.553 0.89561 8.44935 2.25079 7.70031L3.08981 9.48184L11.9274 14.1711C12.1835 14.3071 12.4832 14.3071 12.7394 14.1711L21.5642 9.48859C21.5643 9.48403 21.5643 9.47947 21.5645 9.47492L12.7529 4.6046ZM6.82568 13.6912V16.8053C6.82568 17.1733 7.01218 17.5115 7.31124 17.6859L11.8959 20.3593C12.169 20.5186 12.4977 20.5186 12.7709 20.3593L17.3555 17.6859C17.6546 17.5115 17.8411 17.1733 17.8411 16.8053V13.6912L13.5514 15.9673C12.7831 16.375 11.8837 16.375 11.1152 15.9673L6.82568 13.6912Z",
    fill: "#10A37F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpCenter);
export default __webpack_public_path__ + "static/media/HelpCenter.949dbc722d9f547d9ff188fe0ce44340.svg";
export { ForwardRef as ReactComponent };